import { useMyContext } from 'Context/MyContextProvider';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from 'store/slices/authSlice';
import useAgentStatus from '../SupportAgent/AgentStatus';

const Logout = () => {
    const { navigate, setTemplates, userRole, broadcastLogout,removeFcmToken } = useMyContext();
    const dispatch = useDispatch();
    const { updateAgentStatus } = useAgentStatus();
    
    const handleSignOut = async () => {
        if (userRole === 'Support Agent') {
            await updateAgentStatus('offline');
        }
        
        // Broadcast logout to all other tabs
        broadcastLogout('logout_page');
        
        removeFcmToken();
        await dispatch(logout());
        setTemplates([]);
        localStorage.removeItem('AUTH_TOKEN');
        navigate('/login');
    }
    
    useEffect(() => {
        handleSignOut();
    }, []);

    return null;
};

export default Logout;
